import { useEffect } from "react";
import "./landscapeGuard.css";

// En telefonos la app solo se usa en horizontal. Los navegadores no permiten
// bloquear la orientacion en una pagina normal (iOS no lo soporta y Android
// solo en pantalla completa / PWA), asi que en vertical se cubre la app con un
// aviso para girar el dispositivo. La visibilidad la controla el CSS.
export default function LandscapeGuard() {
  useEffect(() => {
    const orientation: any = (screen as any).orientation;
    orientation?.lock?.("landscape")?.catch(() => {
      // No soportado fuera de pantalla completa: queda el aviso por CSS.
    });
  }, []);

  return (
    <div className="landscape-guard" role="alertdialog" aria-modal="true">
      <div className="landscape-guard__content">
        <div className="landscape-guard__phone" aria-hidden="true">
          <span className="landscape-guard__notch" />
        </div>
        <h2 className="landscape-guard__title">Gira tu dispositivo</h2>
        <p className="landscape-guard__text">
          Fishweb está diseñado para usarse en modo horizontal. Gira tu teléfono
          para continuar.
        </p>
      </div>
    </div>
  );
}
